import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Action Types
export const FETCH_GEOFENCE_REQUEST = "FETCH_GEOFENCE_REQUEST";
export const FETCH_GEOFENCE_SUCCESS = "FETCH_GEOFENCE_SUCCESS";
export const FETCH_GEOFENCE_FAILURE = "FETCH_GEOFENCE_FAILURE";

export const DELETE_GEOFENCE_REQUEST = "DELETE_GEOFENCE_REQUEST";
export const DELETE_GEOFENCE_SUCCESS = "DELETE_GEOFENCE_SUCCESS";
export const DELETE_GEOFENCE_FAILURE = "DELETE_GEOFENCE_FAILURE";

// Fetch all Park Geofence Details
export const fetchParkGeofenceDetails = () => {
  return async (dispatch) => {
    dispatch({ type: FETCH_GEOFENCE_REQUEST });
    const token = localStorage.getItem("token");

    try {
      const response = await axios.get(`${BASE_URL}/v1/api/parkGeofenceDetails`, {
        headers: { authorization: token },
      });

      dispatch({
        type: FETCH_GEOFENCE_SUCCESS,
        payload: response.data.data,
      });
    } catch (error) {
      dispatch({
        type: FETCH_GEOFENCE_FAILURE,
        payload: error.response?.data?.meta?.message || error.message,
      });
    }
  };
};

// Delete a Park Geofence by ID
export const deleteParkGeofence = (id) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_GEOFENCE_REQUEST });
    const token = localStorage.getItem("token");

    try {
      const response = await axios.delete(`${BASE_URL}/v1/api/park-geofence/${id}`, {
        headers: { authorization: token },
      });

      dispatch({
        type: DELETE_GEOFENCE_SUCCESS,
        payload: response.data.data, // returns { id: 2 } for example
      });

      return response.data;
    } catch (error) {
      dispatch({
        type: DELETE_GEOFENCE_FAILURE,
        payload: error.response?.data?.meta?.message || error.message,
      });
      throw error;
    }
  };
};
